export const Environments = {
  SIBIU: 'sibiu',
  TGMURES: 'tgmures',
  SLOBOZIA: 'slobozia',
  CARGES: 'carges',
  ROVINARI: 'rovinari',
  PITESTI: 'pitesti',
};

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'application/pdf',
];

export const ALLOWED_FILE_ACCEPT = '.jpeg,.jpg,.pdf,.png,.bmp';
